import type { MatchFilters } from "./matchFiltersSchema";

// Фильтры под кнопкой «Ещё фильтры»: на кнопке — сколько из них включено.
export const EXTRA_FILTERS = [
  "analyzed",
  "duration",
  "deaths",
  "place",
] as const satisfies readonly (keyof MatchFilters)[];
